import { Box, Flex, Heading, Select, Spacer, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import NextImage from "next/legacy/image";
import {
  CREDITS_PER_ESSAY,
  CREDITS_PER_PROFILE,
  ESSAY_50,
  ESSAY_PASS_1_MO,
  ESSAY_PASS_3_MO,
  PROFILE_150,
  PROFILE_50,
  PROFILE_500,
} from "@/utils/data/products";

const recommendations = [
  [
    {
      profilePlan: PROFILE_150,
      essayPlan: undefined,
      description:
        "Great timing - starting early pays back. Start by exploring profiles in the school of your choice and come back later to revise your essay drafts. You might consider adding a school or two to your list. Good luck!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: undefined,
      description:
        "Great timing - starting early pays back. Start by exploring profiles in the schools of your choice and come back later to revise your essay drafts. Good luck!",
    },
    {
      profilePlan: PROFILE_500,
      essayPlan: undefined,
      description:
        "Great timing - starting early pays back. Start by exploring profiles in the schools of your choice and come back later to revise your essay drafts. Good luck!",
    },
    {
      profilePlan: PROFILE_500,
      essayPlan: undefined,
      description:
        "Great timing - starting early pays back. Start by exploring profiles in the schools of your choice and come back later to revise your essay drafts. Good luck!",
    },
  ],
  [
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_50,
      description:
        "You are right on track! Explore profiles in the school of your choice and use our essay revision tool to improve your Personal Statement. You might consider adding a school or two to your list. Rooting for you!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_3_MO,
      description:
        "You are right on track! Explore profiles in the schools of your choice and use our essay revision tool to improve your drafts. Early start pays off!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_3_MO,
      description:
        "You are right on track! Explore profiles in the schools of your choice and use our essay revision tool to improve your drafts. Early start pays off!",
    },
    {
      profilePlan: PROFILE_500,
      essayPlan: ESSAY_PASS_3_MO,
      description:
        "Your plan is ambitious - and you have no time to waste. Explore profiles in the schools of your choice and use our essay revision tool to improve your drafts. Tackle one school at a time. Good luck!",
    },
  ],
  [
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_50,
      description:
        "You are right on track! Explore profiles in the school of your choice and use our essay revision tool to take your Personal Statement to the next level! You still have time to add a couple of schools to your list.",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "This must be a busy time and we are here to help. Feel free to read inspirational profiles from the schools of your choice, but most importantly, focus on developing your unique story. Essay revision tool will help you to do so. Good luck!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "This must be a busy time and we are here to help. Feel free to read inspirational profiles from the schools of your choice, but most importantly, focus on developing your unique story. Essay revision tool will help you to do so. Good luck!",
    },
    {
      profilePlan: PROFILE_500,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "Your plan is ambitious and we are here to help. Feel free to read inspirational profiles from the schools of your choice, but most importantly, focus on developing your unique story. Essay revision tool will help you to do so. Good luck!",
    },
  ],
  [
    {
      profilePlan: PROFILE_50,
      essayPlan: ESSAY_50,
      description:
        "This is a final stretch! Get inspired by profiles from the school of your choice and let our essay revision tool help you with you essays. Good luck!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "This is a final stretch! Get inspired by profiles from the schools of your choice and let our essay revision tool help you polish you essays. Good luck!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "This is a final stretch! Get inspired by profiles from the schools of your choice and let our essay revision tool help you polish your numerous drafts. Good luck!",
    },
    {
      profilePlan: PROFILE_150,
      essayPlan: ESSAY_PASS_1_MO,
      description:
        "This is a final stretch! Get inspired by profiles from the schools of your choice and let our essay revision tool help you polish your numerous drafts. Good luck!",
    },
  ],
];

const PlanDecisionTree = ({ setSelectedProfilePlan, setSelectedEssayPlan }) => {
  const [noColleges, setNoColleges] = useState(-1);
  const [deadline, setDeadline] = useState(-1);
  const [recommendation, setRecommendation] = useState(undefined);

  useEffect(() => {
    const value = recommendations[deadline]?.[noColleges];

    if (!value) {
      setSelectedProfilePlan(null);
      setSelectedEssayPlan(null);

      setRecommendation(null);

      return;
    }

    setRecommendation(value);

    setSelectedProfilePlan(value.profilePlan);

    setSelectedEssayPlan(value.essayPlan);
  }, [deadline, noColleges]);

  return (
    <Flex
      backgroundImage="linear-gradient(to right, #29051B, #89047F)"
      borderRadius="14px"
      p={5}
      flexDir="column"
      gap={2}
    >
      <Box
        sx={{
          width: "70px",
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-40px",
          alignSelf: "center",
          background: "#fff",
          borderRadius: "50%",
          border: "5px solid #D842A0",
        }}
      >
        <NextImage src="/images/plans/female-student.png" width="40px" height="40px" />
      </Box>

      <Heading as="h3" fontSize="2xl" fontWeight="bold" textAlign="center" color="#fff">
        Which one is right for me?
      </Heading>

      <Text fontSize="lg" textAlign="center" color="#fff">
        Answer two simple questions to see what is recommended
      </Text>

      <Flex alignItems="center" gap={2}>
        <NextImage src="/images/plans/school.png" width="40px" height="40px" />
        <Heading as="h3" fontSize="lg" fontWeight="bold" color="#fff">
          How many colleges do you plan to apply to?
        </Heading>
      </Flex>

      <Box sx={{ maxWidth: "200px", alignSelf: "flex-end" }}>
        <Select
          sx={{
            width: "100%",
            background: "#ffffff",
            borderRadius: "4px",
          }}
          value={noColleges}
          onChange={(e) => {
            setNoColleges(e.target.value);
          }}
          placeholder="# of colleges"
        >
          <option value={0}>1 college</option>
          <option value={1}>2 - 4 colleges</option>
          <option value={2}>5 - 8 colleges</option>
          <option value={3}>9 or more</option>
        </Select>
      </Box>

      <Flex alignItems="center" gap={2}>
        <NextImage src="/images/plans/calendar.png" width="40px" height="40px" />
        <Heading as="h3" fontSize="lg" fontWeight="bold" color="#fff">
          When is the deadline for your application?
        </Heading>
      </Flex>

      <Box sx={{ maxWidth: "200px", alignSelf: "flex-end" }}>
        <Select
          sx={{
            width: "100%",
            background: "#ffffff",
            borderRadius: "4px",
          }}
          value={deadline}
          onChange={(e) => {
            setDeadline(e.target.value);
          }}
          placeholder="Deadline"
        >
          <option value={0}>Next year</option>
          <option value={1}>In several months</option>
          <option value={2}>Next month</option>
          <option value={3}>Very very soon</option>
        </Select>
      </Box>

      {!!recommendation && (
        <Box>
          <Flex alignItems="stretch" justifyContent="center" gap={2} flexWrap="wrap" my={3}>
            {recommendation?.profilePlan && (
              <Flex
                flexDirection="column"
                align="center"
                justifyContent="center"
                maxWidth="200px"
                bg="#DFEFFD"
                borderRadius="10px"
                p={2}
                w={40}
              >
                <Flex>
                  <NextImage src="/images/icons/credits-icon.svg" width="20px" height="20px" />
                  <Text fontWeight={600}>{recommendation.profilePlan.credits}</Text>
                </Flex>

                <Text fontSize={"12px"}>
                  {Math.round(recommendation.profilePlan.credits / CREDITS_PER_PROFILE)} profiles
                </Text>
              </Flex>
            )}

            {recommendation?.essayPlan && (
              <Flex
                flexDirection="column"
                align="center"
                justifyContent="center"
                maxWidth="200px"
                bg="#DFEFFD"
                borderRadius="10px"
                p={2}
                w={40}
              >
                {!recommendation?.essayPlan.period ? (
                  <>
                    <Flex alignItems="center">
                      <NextImage src="/images/icons/credits-icon.svg" width="20px" height="20px" />
                      <Text fontWeight={600}>{recommendation?.essayPlan.credits}</Text>
                    </Flex>
                    <Text fontSize={"12px"}>
                      {Math.round(recommendation?.essayPlan.credits / CREDITS_PER_ESSAY)} revisions
                    </Text>
                  </>
                ) : (
                  <>
                    <Flex alignItems="center">
                      <NextImage src="/images/icons/essay-credits.svg" width="30px" height="30px" />
                      <Text fontWeight={600} lineHeight="16px">
                        {recommendation?.essayPlan.title}
                      </Text>
                    </Flex>
                    <Text fontSize="12px">
                      worth {recommendation?.essayPlan.initialPrice} Credits
                    </Text>
                  </>
                )}
              </Flex>
            )}
          </Flex>

          <Text fontSize="lg" color="#fff">
            {recommendation.description}
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default PlanDecisionTree;
